import _ from 'lodash'

import {
  LIST_PERMISSION_ASSIGNMENTS_STARTED,
  LIST_PERMISSION_ASSIGNMENTS_COMPLETED,
  LIST_PERMISSION_ASSIGNMENTS_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalPermission } from '@/utils/marshal'

function getDefaultState () {
  return {
    permissionAssignments: [],
    loading: false,
    error: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [LIST_PERMISSION_ASSIGNMENTS_STARTED] (state) {
      state.loading = true
    },
    [LIST_PERMISSION_ASSIGNMENTS_COMPLETED] (state, payload) {
      const { permissionAssignments, isMarshalNeeded } = payload
      if (isMarshalNeeded) {
        state.permissionAssignments = _.cloneDeep(permissionAssignments.map(marshalPermission))
      } else {
        state.permissionAssignments = _.cloneDeep(permissionAssignments)
      }
      state.loading = false
      state.error = undefined
    },
    [LIST_PERMISSION_ASSIGNMENTS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined } }, roleId) {
      try {
        commit(LIST_PERMISSION_ASSIGNMENTS_STARTED)
        const permissionAssignments = await client.managementClient.listPermissionAssignments(roleId)
        commit(LIST_PERMISSION_ASSIGNMENTS_COMPLETED, {
          permissionAssignments: permissionAssignments,
          isMarshalNeeded: true
        })
      } catch (err) {
        commit(LIST_PERMISSION_ASSIGNMENTS_FAILED, err)
      }
    }
  }
}
